<div class="green-score-calculator-wrapper">
  <div class="green-score-calculator-container" fxLayout="column" fxLayoutGap="1em">
    <h2>{{ 'GREEN_SCORE.TITLE' | translate }}</h2>
    <div class="method-select">
      <span>{{ 'GREEN_SCORE.CHOOSE_METHOD' | translate }}</span>
      <p-selectButton [options]="methods" [(ngModel)]="selectedMethod" (onChange)="calcChange(null,null)"></p-selectButton>
    </div>

<!--    <p-dropdown (onChange)="calcChange(null,null)" [options]="methods" [(ngModel)]="selectedMethod"-->
<!--                placeholder="בחר שיטת ציון ירוק"></p-dropdown>-->
    <p-table [columns]="columns" [value]="items" styleClass="p-datatable-gridlines">
      <ng-template pTemplate="header">
        <tr>
          <th *ngFor="let col of columns">{{col.header}}</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-columns="columns" let-rowData>
        <tr>
          <td *ngFor="let col of columns" pEditableColumn>
            <p-cellEditor *ngIf="col.field!=='variable';else permanent">
              <ng-template pTemplate="input">
                <input type="number" fxFlex [(ngModel)]="rowData[col.field]" (keyup)="calcChange($event,rowData)"
                       class="var-input">
              </ng-template>
              <ng-template pTemplate="output">
                {{rowData[col.field]}}
              </ng-template>
            </p-cellEditor>
            <ng-template #permanent>
              <span>{{rowData[col.field]}}</span>
            </ng-template>
          </td>
        </tr>
      </ng-template>
    </p-table>
    <div class="summery-score-row" fxLayout="column" fxLayoutGap="1em">
      <div class="green-score" fxLayout="row" fxLayoutGap="1em">
        <span>{{ 'GREEN_SCORE.GREEN_SCORE_LABEL' | translate }}</span>
        <span>{{greenScore || 0}}</span>
      </div>
      <div class="pol-score"  fxLayout="row" fxLayoutGap="1em">
        <span>{{ 'GREEN_SCORE.POLLUTION_GROUP' | translate }}</span>
        <span>{{pollutionGroup || 0}}</span>
      </div>
      <div class="discount"  fxLayout="row" fxLayoutGap="1em">
        <span>{{ 'GREEN_SCORE.POLLUTION_DISCOUNT' | translate }}</span>
        <span>{{(discount?.discount || 0)|currency:'ILS'}}</span>
      </div>
    </div>
    <div class="button-container" fxLayout="row" fxLayoutAlign="flex-end">
      <button mat-raised-button color="primary" (click)="saveScore()">{{ 'GREEN_SCORE.SAVE_SCORE' | translate }}</button>
    </div>
  </div>
</div>
